export const ConfigType = {
  EXTERNAL_USER_MANUAL: 'EXTERNAL_USER_MANUAL',
  OFFER_CONDITION_OF_PURCHASE_FILE: 'OFFER_CONDITION_OF_PURCHASE_FILE',
}
